export default __webpack_public_path__ + "static/media/orange-map-dot.8b9293fa.svg";